import validate from "/builds/asar-studio/ticket-me-biz/ticketme/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@20.14.15_eslint@8.57.0_ioredis@5.4.1_magicast@0_a4kabqj7nm2m3whzilcjt2b5yy/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/asar-studio/ticket-me-biz/ticketme/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@20.14.15_eslint@8.57.0_ioredis@5.4.1_magicast@0_a4kabqj7nm2m3whzilcjt2b5yy/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/shop/src/middleware/auth.ts")
}